module.exports = __webpack_public_path__ + "img/PublicOutlined.9af99451.svg";